/** Data em ISO (AAAA-MM-DD), no fuso local — nunca via toISOString(), que desloca o dia. */
export function toIsoDate(data) {
  return `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, '0')}-${String(data.getDate()).padStart(2, '0')}`
}

/**
 * Período padrão dos modais de período do módulo NF: o mês anterior completo,
 * que é o recorte usado tanto no download em lote quanto no relatório Caixa.
 */
export function periodoInicial(hoje = new Date()) {
  const inicio = new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1)
  const fim = new Date(hoje.getFullYear(), hoje.getMonth(), 0)
  return { inicio: toIsoDate(inicio), fim: toIsoDate(fim) }
}

/** Um período só é utilizável quando as duas datas existem e estão na ordem certa. */
export function periodoValido(periodo) {
  return Boolean(periodo?.inicio && periodo?.fim && periodo.inicio <= periodo.fim)
}
